import { useEffect } from 'react';
import { Outlet, useMatches } from 'react-router';
import ConditionalLayout from '@/components/layouts/conditional-layout';
import useFileSizeLimit from '@/hooks/files/use-file-size-limit';
import useLogger from '@/hooks/use-logger';
import { useUnblockSoundEffect } from '@/hooks/use-unblock-sound-effect';
import ROUTES from '@/routes';
import MessagesIndexRoute from '@/routes/messages/index';
import { useAuthStore } from '@/stores/auth';
import { useMessageStore } from '@/stores/message';

export default function MessagesLayout() {
  const { data: fileSizeLimit } = useFileSizeLimit();
  const logger = useLogger('Sentry');
  const matches = useMatches();

  useUnblockSoundEffect();
  useEffect(() => {
    if (fileSizeLimit?.TracesSampleRate) {
      logger.current.info('tracesSampler AuthLayout', fileSizeLimit.TracesSampleRate);
      useAuthStore.getState().updateTraceRate(fileSizeLimit.TracesSampleRate ?? 0.01);
    }
  }, [fileSizeLimit?.TracesSampleRate, logger]);

  useEffect(() => {
    const lastMatch = matches.at(-1);
    if (lastMatch?.pathname.replace(/\/$/gi, '') === ROUTES.MESSAGES.$path()) {
      useMessageStore.getState().resetKey();
    }
  }, [matches]);

  return (
    <ConditionalLayout pathname={ROUTES.MESSAGES.$path()}>
      {(isDesktop, match) => (
        <>
          {isDesktop ? (
            <>
              <div className='w-[352px] h-full flex'>
                <MessagesIndexRoute />
              </div>
              {/* 此Outlet用於顯示聊天室內的Modal*/}
              {/* 聊天室不經由此Outlet，由PanelLayout與LayoutStore控制 */}
              <Outlet />
            </>
          ) : match ? (
            <MessagesIndexRoute />
          ) : (
            <Outlet />
          )}
        </>
      )}
    </ConditionalLayout>
  );
}
